import { DmsAnalyticsCard } from "./DmsAnalyticsCard";
import { DmsAnalyticsHeader } from "./DmsAnalyticsHeader";
import { DmsAnalyticsBody } from "./DmsAnalyticsBody";
import { DmsAnalyticsChips } from "./DmsAnalyticsChips";
import { DmsAnalyticsFilters } from "./DmsAnalyticsFilters";
import { DmsAnalyticsPeriodPicker } from "./DmsAnalyticsPeriodPicker";
import { DmsAnalyticsBar } from "./DmsAnalyticsBar";
import { DmsAnalyticsFlow } from "./DmsAnalyticsFlow";
import { DmsAnalyticsTable } from "./DmsAnalyticsTable";
import { DmsAnalyticsTraceability } from "./DmsAnalyticsTraceability";

export const DmsAnalytics = {
    Card: DmsAnalyticsCard,
    Header: DmsAnalyticsHeader,
    Body: DmsAnalyticsBody,
    Chips: DmsAnalyticsChips,
    Filters: DmsAnalyticsFilters,
    PeriodPicker: DmsAnalyticsPeriodPicker,
    Bar: DmsAnalyticsBar,
    Flow: DmsAnalyticsFlow,
    Table: DmsAnalyticsTable,
    Traceability: DmsAnalyticsTraceability,
};
